import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SignatureDto } from '@shared/src/dtos/signature/SignatureDto';
import { FileTypes } from '@shared/src/enums/FileTypes';
import { HString } from '@shared/src/public-api';

@Component({
    selector: 'shared-signature-maintenance-component',
    templateUrl: './shared.signature.maintenance.component.html',
    styleUrls: ['./shared.signature.maintenance.component.scss']
})
export class SharedSignatureMaintenanceComponent {

    @Input() public readonly: boolean = false;

    private _value: SignatureDto;
    @Input()
    public set value(value: SignatureDto) {
        this._value = value;
        this.loadData(value);
    }
    public get value(): SignatureDto {
        return this._value;
    }

    @Output() valueChange: EventEmitter<SignatureDto> = new EventEmitter();

    public fileSignatureBytes: any;
    public fileSignatureType: FileTypes = FileTypes.png;
    public hasChanges: boolean = false;

    public loadData(data: SignatureDto) {
        this.fileSignatureBytes = (data && data.fileContent) ? HString.toBase64ToArrayBuffer(data.fileContent) : null;
        this.fileSignatureType = (data && data.fileType) ? data.fileType : FileTypes.png;
        this.hasChanges = false;
    }

    public onEndDrawSignature(signature: any) {
        this.fileSignatureBytes = signature.signbytes;
        this.fileSignatureType = signature.bytestype;
        this.hasChanges = true;
    }

    // Es crida tant quan l'usuari clica "Limpiar" al canvas com quan aquest component
    // assigna fileSignatureBytes=null internament (p.ex. en carregar un value sense firma).
    // Només volem propagar el buidatge quan realment hi havia alguna cosa a esborrar.
    public onClearSignature($event: any) {
        let hadSomething = this.hasChanges || (this.value != null && this.value.fileContent != null);
        this.hasChanges = false;
        if (!hadSomething)
            return;

        let result = new SignatureDto();
        result.fileType = null;
        result.fileContent = null;
        result.signedAt = null;
        this.valueChange.next(result);
    }

    public cancelSignature() {
        this.loadData(this.value);
    }

    public doSignature() {
        let result = new SignatureDto();
        result.fileType = this.fileSignatureType;
        result.fileContent = this.fileSignatureBytes;
        this.valueChange.next(result);
    }
}
